import React, { useState, useEffect } from 'react'
import config from '../config'
import axios from 'axios'
import { Storage } from 'aws-amplify'

const Pixabay = ({ closeUnsplash, selectImage }) => {
    const [isSearching, setSearching] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [data, setData] = useState([])
    const [isUploading, setUploading] = useState(false)

    useEffect(() => {
        return () => {
            setUploading(false)
        }
    }, [])

    const handleSearch = () => {
        setSearching(true)
        searchPixabay().then((data) => {
            setSearching(false)
            setData(data)
        })
    }

    const searchPixabay = async () => {
        try {
            // 1. Point to your new Render API base URL
            const API_BASE = process.env.REACT_APP_API_URL;
            const api_url = `${API_BASE}/pixabay`;

            const results = await axios.get(api_url, {
                params: {
                    q: searchValue,
                    image_type: 'photo',
                    per_page: 100,
                },
            })

            return results.data
        } catch (err) {
            setSearching(false)
            alert('Something went wrong getting pixabay images')
            return err
        }
    }

    const handleImageClick = ({ largeImageURL, previewURL, tags }) => {
        /**
         * Handle upload process to s3
         * Then close image picker modal with new image URL
         */

        setUploading(true)

        handleS3Upload(largeImageURL, previewURL).then((images) => {
            /**
             * Uplaod was complete, return image object
             */
            let mediaObject = {
                url: `${config.imageBasePath}${images[0].key}`,
            }

            setUploading(false)
            selectImage(mediaObject.url)
            closeUnsplash()
        })
    }

    const handleS3Upload = async (url, url_thumbnail) => {
        try {
            const date = new Date()
            const year = date.getFullYear()
            const month = date.getMonth() + 1
            const expirationDate = date.getTime() + 31557600 //one year in seconds
            const fileExtension = 'jpg'

            const file = await fetch(url).then((r) => r.blob())
            const file_thumbnail = await fetch(url_thumbnail).then((r) =>
                r.blob()
            )

            const filename = `${year}/${month}/${Date.now()}.${fileExtension}`

            /**
             * Store regular image on s3
             */
            const stored = await Storage.put(filename, file, {
                contentType: 'image/jpeg',
                cacheControl: 'max-age=30758400',
                expires: expirationDate,
                contentEncoding: 'gzip',
                metadata: {
                    contentEncoding: 'gzip',
                    expires: expirationDate.toString(),
                },
            })

            return Promise.all([stored]).then((images) => {
                // return images
                return images
            })
        } catch (err) {
            alert(
                'something went wrong uploading image. Please refresh and try again'
            )
        }
    }

    return (
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-xl p-4 my-24">
            {isUploading && (
                <div className="fixed top-0 left-0 w-screen h-screen z-50 bg-black bg-opacity-50">
                    <div className="flex justify-center items-center py-12 text-white text-2xl text-center">
                        Uploading to post library...
                    </div>
                </div>
            )}
            <div className="flex flex-row items-center justify-between">
                <div>
                    <div className="text-2xl font-semibold">Search Pixabay</div>
                    <div className="text-gray-700 text-sm mb-4">
                        Search Pixabay for royalty free images
                    </div>
                </div>
                <div>
                    <button onClick={() => closeUnsplash()}>
                        <span>
                            <svg
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                stroke="currentColor"
                                strokeWidth="2"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="text-gray-800"
                            >
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </span>
                    </button>
                </div>
            </div>
            <div className="grid grid-cols-12 gap-4">
                <input
                    className="rounded-lg px-4 py-3 text-lg border-2 border-gray-300 focus:border-blue-500 flex-1 outline-none bg-gray-100 focus:bg-white col-span-10"
                    placeholder="Search"
                    value={searchValue}
                    onChange={(event) => setSearchValue(event.target.value)}
                    onKeyPress={(event) =>
                        event.key === 'Enter' ? handleSearch() : null
                    }
                />
                <button
                    onClick={() => handleSearch()}
                    className="px-4 py-3 bg-blue-500 text-white text-lg rounded-lg col-span-2 hover:bg-blue-600"
                >
                    Search
                </button>
            </div>
            {isSearching && (
                <div className="text-center py-12 text-gray-600 text-lg">
                    Loading...
                </div>
            )}
            {!isSearching && data.hits && data.hits.length > 0 && (
                <>
                    <div className="text-gray-700 text-sm py-2 flex flex-row items-center">
                        <div>
                            Total Results:{' '}
                            <span className="font-bold">{data.total}</span>
                        </div>
                        <div className="ml-4 flex flex-row items-center">
                            <span className="text-green-500">
                                <svg
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    fill="none"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    className="w-5 h-5 pr-1"
                                >
                                    <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path>
                                    <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>
                                </svg>
                            </span>
                            Note: Image previews are low resolution. High
                            quality will be used after selecting.
                        </div>
                    </div>
                    <div className="grid grid-cols-6 gap-4 mt-4">
                        {data.hits.map((item) => (
                            <button
                                onClick={() => handleImageClick(item)}
                                className="border-2 border-transparent hover:border-blue-500 transition duration-75 ease-in-out rounded"
                            >
                                <img
                                    className="object-cover w-full h-24 bg-gray-100 rounded"
                                    src={item.webformatURL}
                                />
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}

// import Unsplash, { toJson } from 'unsplash-js'

// const APP_ACCESS_KEY = 'PyZx5ZFFVUBxNvyQCrd_z7VvLDWydDl8nIEz3db6k7o'

// const UnsplashBrowser = ({ closeUnsplash, selectImage }) => {
//     const unsplash = new Unsplash({ accessKey: APP_ACCESS_KEY })
//     const [images, setImages] = useState([])
//     const [currentPage, setCurrentPage] = useState(1)
//     const [imageMeta, setImageMeta] = useState({})
//     const [search, setSearch] = useState('')

//     const searchImages = () => {
//         unsplash.search
//             .photos(search.toLowerCase(), currentPage, 25)
//             .then(toJson)
//             .then((json) => {
//                 // Your code
//                 setImageMeta({
//                     total: json.total,
//                     total_pages: json.total_pages,
//                 })
//                 setImages(json.results)
//             })
//     }

//     const chooseImage = (image_url) => {
//         selectImage(image_url)
//         closeUnsplash()
//     }

//     const keyPress = (e) => {
//         if (e.keyCode === 13) {
//             searchImages()
//         }
//     }

//     return (
//         <div>
//             <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-xl p-4 my-24">
//                 <div className="flex flex-row items-center justify-between mb-4">
//                     <div className="text-gray-800">Image Browser</div>
//                     <button onClick={() => closeUnsplash()}>
//                         <span>
//                             <svg
//                                 viewBox="0 0 24 24"
//                                 width="24"
//                                 height="24"
//                                 stroke="currentColor"
//                                 strokeWidth="2"
//                                 fill="none"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 className="text-gray-800"
//                             >
//                                 <line x1="18" y1="6" x2="6" y2="18"></line>
//                                 <line x1="6" y1="6" x2="18" y2="18"></line>
//                             </svg>
//                         </span>
//                     </button>
//                 </div>
//                 <div className="flex flex-col mb-4">
//                     <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
//                         Search
//                     </label>
//                     <div className="flex flex-row items-center justify-between">
//                         <input
//                             onKeyDown={(e) => keyPress(e)}
//                             name="search"
//                             value={search}
//                             placeholder="Search Images"
//                             onChange={(e) => setSearch(e.target.value)}
//                             className="border-2 border-gray-300 focus:border-blue-500 px-3 py-2 rounded-lg outline-none w-3/4"
//                         />
//                         <button
//                             onClick={() => searchImages()}
//                             className="border-2 border-blue-500 bg-blue-500 hover:bg-blue-600 hover:border-blue-600 text-white px-3 rounded cursor-pointer text-center py-1 shadow outline-none"
//                         >
//                             Search
//                         </button>
//                     </div>
//                 </div>
//                 <div className="grid grid-cols-4 gap-4">
//                     {images.length > 0 &&
//                         images.map((image) => {
//                             return (
//                                 <div
//                                     onClick={() =>
//                                         chooseImage(image.urls.regular)
//                                     }
//                                     className="bg-gray-100 rounded hover:outline h-32 bg-cover hover:curosr hover:shadow-outline"
//                                     style={{
//                                         backgroundImage: `url(${image.urls.thumb})`,
//                                     }}
//                                 ></div>
//                             )
//                         })}
//                 </div>
//             </div>
//         </div>
//     )
// }

export default Pixabay
